/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the ExternalDemandSource HTTP resource (factory product). */
export class ExternalDemandSourceResource {
}

export function createExternalDemandSourceResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'externaldemandsources', () => localUserProfile, 'externalDemandSource');
}

export const externalDemandSourceResourceProvider = {
  provide: ExternalDemandSourceResource,
  useFactory: createExternalDemandSourceResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

